// extracted by mini-css-extract-plugin
export var aboveInput = "_kd-0";
export var actionButton = "_kd-5";
export var actionButtonContainer = "_kd-1";
export var actionIcon = "_kd-6";
export var aiInfoContainer = "_kd-2";
export var attachmentWrapper = "_kd-7";
export var bold = "_kd-3";
export var checkIcon = "_kd-8";
export var clickingRecipientBar = "_kd-11";
export var commentThreadSwitch = "_kd-a";
export var draftImage = "_kd-b";
export var draftImageContainer = "_kd-c";
export var draftImages = "_kd-e";
export var editButton = "_kd-g";
export var editor = "_kd-f";
export var editorContainer = "_kd-y";
export var editorErrorTooltipWrapper = "_kd-9";
export var headerDivider = "_kd-h";
export var icon = "_kd-i";
export var info = "_kd-j";
export var internal = "_kd-n";
export var internalDivider = "_kd-k";
export var internalMessage = "_kd-l";
export var messageInputCard = "_kd-m";
export var messageInputForm = "_kd-o";
export var messageInputFormInternal = "_kd-p";
export var options = "_kd-q";
export var publicMessageCustomer = "_kd-s";
export var publicMessageMerchant = "_kd-r";
export var removeImageButton = "_kd-d";
export var replyButtons = "_kd-t";
export var showSignatureButton = "_kd-u";
export var spinner = "_kd-v";
export var verticalButtonDivider = "_kd-4";
export var visibilitySelector = "_kd-w";
export var warning = "_kd-x";
export var wrappingText = "_kd-z";
export var writingInternalNoteTopBorder = "_kd-10";